export const isChristmasTime = (date = new Date()) => {
  return (
    (date.getMonth() === 11 && date.getDate() <= 24) ||
    (date.getMonth() === 10 && date.getDate() >= 29)
  );
};

export const christmasServiceHoursActive = () => {
  const date = new Date();
  return (
    (date.getMonth() === 11 && date.getDate() <= 22) ||
    (date.getMonth() === 10 && date.getDate() >= 28)
  );
};
